import { BirdRealtime } from '@messagebird/realtime';

/**
 * Thin adapter that exposes the subset of the Laravel Echo API the app relies
 * on (`private()`, `channel()`, `listen()`, `stopListening()`, `leave()`),
 * backed by the Bird Realtime client. This keeps the existing Vue call sites
 * unchanged while broadcasting runs through Bird instead of Pusher.
 */
class BirdChannelAdapter {
    constructor(channel) {
        this.channel = channel;
    }

    listen(event, callback) {
        this.channel.bind(event, callback);
        return this;
    }

    stopListening(event, callback) {
        if (typeof this.channel.unbind === 'function') {
            this.channel.unbind(event, callback);
        }
        return this;
    }
}

export default class BirdEcho {
    constructor(config) {
        this.client = new BirdRealtime(config);
        this.channels = {};
    }

    private(name) {
        return this.subscribeTo(`private-${name}`);
    }

    channel(name) {
        return this.subscribeTo(name);
    }

    subscribeTo(name) {
        if (!this.channels[name]) {
            this.channels[name] = new BirdChannelAdapter(this.client.subscribe(name));
        }

        return this.channels[name];
    }

    leave(name) {
        [name, `private-${name}`, `presence-${name}`].forEach((channelName) => this.leaveChannel(channelName));
    }

    leaveChannel(name) {
        if (!this.channels[name]) {
            return;
        }

        if (typeof this.client.unsubscribe === 'function') {
            this.client.unsubscribe(name);
        }

        delete this.channels[name];
    }
}
